import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';

import { Row } from 'antd';

import styles from './extraPanel.less';
import TabsMenu from '../../common/UI/TabsMenu';


class ExtraHeader extends React.Component {
  static propTypes = {
    scene: PropTypes.object.isRequired,
    catalog: PropTypes.object.isRequired,
    record: PropTypes.object.isRequired,
    tabId: PropTypes.string,
    hasBeenEdit: PropTypes.bool.isRequired,
    isWebForm: PropTypes.bool,
    isNew: PropTypes.bool,
    isLoading: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }


  hideSideBar = () => {

  }

  render() {
    const {
      tabs,
      tabId,
      onTabChange,
      t,
    } = this.props;

    return (
      <div className={styles.header}>
        <Row type="flex" justify="space-between" align="middle" className={styles.containerHeader}>
          <h2 className={styles.headerText}>{t(`record.tabs.${tabId}`)}</h2>
        </Row>
        <Row className={styles.tabsContainer}>
          <TabsMenu
            items={tabs}
            activeId={tabId}
            className={styles.tabs}
            onClick={onTabChange}
          />
        </Row>
      </div>
    );
  }
}

export default withTranslation()(ExtraHeader);